import React from "react";
// @material-ui/core components
import { useTheme } from "@material-ui/core/styles";
import Avatar from "@material-ui/core/Avatar";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
// @material-ui/icons components
import Business from "@material-ui/icons/Business";
import Check from "@material-ui/icons/Check";

// core components
import AuthHeader from "components/Headers/AuthHeader.js";
import CardPricing from "components/Cards/Pricing/CardPricing.js";
import CardPricingGradient from "components/Cards/Pricing/CardPricingGradient.js";

function Pricing() {
  const theme = useTheme();
  const tableRows = [
    {
      FIELD1: "IMAP/POP Support",
      FIELD2: (
        <Box
          sx={{
            width: "1.25rem!important",
            height: "1.25rem!important",
            color: theme.palette.success.main,
          }}
          component={Check}
        />
      ),
      FIELD3: (
        <Box
          sx={{
            width: "1.25rem!important",
            height: "1.25rem!important",
            color: theme.palette.success.main,
          }}
          component={Check}
        />
      ),
    },
    {
      FIELD1: "Email Forwarding",
      FIELD2: (
        <Box
          sx={{
            width: "1.25rem!important",
            height: "1.25rem!important",
            color: theme.palette.success.main,
          }}
          component={Check}
        />
      ),
      FIELD3: (
        <Box
          sx={{
            width: "1.25rem!important",
            height: "1.25rem!important",
            color: theme.palette.success.main,
          }}
          component={Check}
        />
      ),
    },
    {
      FIELD1: "Active Sync",
      FIELD2: (
        <Box
          sx={{
            width: "1.25rem!important",
            height: "1.25rem!important",
            color: theme.palette.success.main,
          }}
          component={Check}
        />
      ),
      FIELD3: (
        <Box
          sx={{
            width: "1.25rem!important",
            height: "1.25rem!important",
            color: theme.palette.success.main,
          }}
          component={Check}
        />
      ),
    },
    {
      FIELD1: "Multiple domain hosting",
      FIELD2: (
        <Box
          sx={{
            width: "1.25rem!important",
            height: "1.25rem!important",
            color: theme.palette.success.main,
          }}
          component={Check}
        />
      ),
      FIELD3: "Limited to 1 domain only",
    },
    {
      FIELD1: "Additional storage upgrade",
      FIELD2: (
        <Box
          sx={{
            width: "1.25rem!important",
            height: "1.25rem!important",
            color: theme.palette.success.main,
          }}
          component={Check}
        />
      ),
      FIELD3: (
        <Box
          sx={{
            width: "1.25rem!important",
            height: "1.25rem!important",
            color: theme.palette.success.main,
          }}
          component={Check}
        />
      ),
    },
    {
      FIELD1: "30MB Attachment Limit",
      FIELD2: (
        <Box
          sx={{
            width: "1.25rem!important",
            height: "1.25rem!important",
            color: theme.palette.success.main,
          }}
          component={Check}
        />
      ),
      FIELD3: "-",
    },
    {
      FIELD1: "Password protected / Expiry links",
      FIELD2: (
        <Box
          sx={{
            width: "1.25rem!important",
            height: "1.25rem!important",
            color: theme.palette.success.main,
          }}
          component={Check}
        />
      ),
      FIELD3: "-",
    },
    {
      FIELD1: "Unlimited Custom Apps",
      FIELD2: (
        <Box
          sx={{
            width: "1.25rem!important",
            height: "1.25rem!important",
            color: theme.palette.success.main,
          }}
          component={Check}
        />
      ),
      FIELD3: "-",
    },
  ];
  return (
    <>
      <AuthHeader title="Choose the best plan for your business" />
      {/* Page content */}
      <Container
        component={Box}
        maxWidth="xl"
        sx={{
          marginTop: "-8rem",
          paddingBottom: "3rem",
          position: "relative",
          zIndex: "101",
        }}
      >
        <Box component={Grid} container sx={{ justifyContent: "center" }}>
          <Grid item xs={12} lg={10}>
            <Box
              sx={{
                marginBottom: "3rem",
                display: "flex",
                flexDirection: "column",
                "&>.MuiCard-root": {
                  marginBottom: "15px",
                },
                [theme.breakpoints.up("sm")]: {
                  flexDirection: "row!important",
                },
                [theme.breakpoints.up("sm")]: {
                  flexFlow: "row wrap",
                  "&>.MuiCard-root": {
                    flex: "1 0",
                    marginBottom: 0,
                  },
                  "&>.MuiCard-root:first-of-type,&>.MuiCard-root:not(:last-of-type)": {
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                  },
                  "&>.MuiCard-root:last-of-type,&>.MuiCard-root:not(:first-of-type)": {
                    borderTopLeftRadius: 0,
                    borderBottomLeftRadius: 0,
                  },
                  "&>.MuiCard-root+.MuiCard-root": {
                    marginLeft: "0",
                    borderLeft: "0",
                  },
                },
              }}
            >
              <CardPricing />
              <CardPricingGradient />
            </Box>
          </Grid>
        </Box>
        <Box
          sx={{
            display: "flex",
            paddingLeft: "1rem",
            paddingRight: "1rem",
            marginTop: "3rem",
            color: theme.palette.white.main,
            alignItems: "center",
            [theme.breakpoints.up("md")]: {
              justifyContent: "center",
            },
          }}
        >
          <div>
            <Avatar sx={{ backgroundColor: theme.palette.white.main }}>
              <Business
                sx={{
                  color: theme.palette.primary.main,
                  width: "1.5rem!important",
                  height: "1.5rem!important",
                }}
              />
            </Avatar>
          </div>
          <Grid item xs={12} lg={6}>
            <Box
              component="p"
              sx={{
                fontWeight: "300",
                lineHeight: "1.7",
                marginBottom: "1rem",
                marginTop: "1rem",
              }}
            >
              <Box component="strong" sx={{ fontWeight: 700 }}>
                The Arctic Ocean
              </Box>{" "}
              freezes every winter and much of the sea-ice then thaws every
              summer, and that process will continue whatever.
            </Box>
          </Grid>
        </Box>
        <Grid container component={Box} sx={{ justifyContent: "center" }}>
          <Grid item xs={12} lg={10}>
            <TableContainer component={Box} sx={{ marginTop: "3rem" }}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell
                      algin="left"
                      sx={{
                        borderTopColor: theme.palette.dark.tableBorder,
                        color: theme.palette.gray[400],
                        fontSize: ".65rem",
                      }}
                    >
                      Features
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        borderTopColor: theme.palette.dark.tableBorder,
                        color: theme.palette.gray[400],
                        fontSize: ".65rem",
                      }}
                    >
                      Bravo Pack
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        borderTopColor: theme.palette.dark.tableBorder,
                        color: theme.palette.gray[400],
                        fontSize: ".65rem",
                      }}
                    >
                      Alpha Pack
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tableRows.map((prop, key) => (
                    <TableRow
                      key={key}
                      sx={{
                        "&:last-of-type .MuiTableCell-body": {
                          border: 0,
                        },
                      }}
                    >
                      <TableCell
                        algin="left"
                        sx={{
                          borderBottomColor: theme.palette.dark.tableBorder,
                          color: theme.palette.background.default,
                        }}
                      >
                        {prop.FIELD1}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          borderBottomColor: theme.palette.dark.tableBorder,
                          color: theme.palette.background.default,
                        }}
                      >
                        {prop.FIELD2}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          borderBottomColor: theme.palette.dark.tableBorder,
                          color: theme.palette.background.default,
                        }}
                      >
                        {prop.FIELD3}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export default Pricing;
